<template>
  <div v-if="travelDetails">
    <div style="background: #E5E5E5; height: 7px"></div>
    <div class="boarding__history">
      <div class="travel__schedule">
        <div class="schedule__info">
          <div class="row q-py-sm">
            <div
              class="text-caption text-weight-bold"
            >{{travelDetails.boarding_name+' '+travelDetails.boarding_uf}}</div>
            <q-icon name="arrow_forward" class="q-mx-sm" style="color: #37C100; font-size:1.5em" />
            <div
              class="text-caption text-weight-bold"
            >{{travelDetails.landing_name+' '+travelDetails.landing_uf}}</div>
          </div>
        </div>
        <q-separator inset />
      </div>
      <div class="column q-pl-md q-py-sm">
        <span style="color: #7A8583; font-size: 10px">
          Saída dia
          <span
            class="text-weight-bold"
          >{{ travelDetails.departure_datetime | formatDate }}</span>
        </span>
        <span style="color: #7A8583; font-size: 10px">
          Saída da agência
          <span
            class="text-weight-bold"
          >{{ travelDetails.departure_date +' '+ travelDetails.departure_time | formatDate }}</span>
        </span>
      </div>
    </div>
    <div class="passengers__history">
      <div style="padding: 20px 20px 30px 20px">
        <span class="text-weight-bold text-black">PASSAGEIROS</span>
      </div>
      <q-tabs
        v-model="option"
        dense
        left-icon="none"
        right-icon="none"
        no-caps
        class="tabs row justify-center"
        style="border-bottom: 1px solid #CCCCCC"
      >
        <q-tab name="Embarque" :class="option === 'Embarque' ? 'selected' : 'unselected'">
          <i class="ri-arrow-up-circle-line" style="font-size: 25px"></i>
          <span>Embarque</span>
          <q-badge
            floating
            class="text-bold"
            :style="option === 'Embarque' ? 'background: #004923; color: white' : 'background: #808285; color: black'"
            style="margin-right: 17px; margin-top: -3px; border-radius: 100%;"
          >{{filterType('Embarque').length}}</q-badge>
        </q-tab>
        <q-tab name="Desembarque" :class="option === 'Desembarque' ? 'selected' : 'unselected'">
          <i class="ri-arrow-down-circle-fill" style="font-size: 25px"></i>
          <span>Desembarque</span>
          <q-badge
            :style="option === 'Desembarque' ? 'background: #004923; color: white;' : 'background: #808285; color: black'"
            class="text-white text-bold"
            floating
            style="margin-right: 28px; margin-top: -3px; border-radius: 100%"
          >{{filterType('Desembarque').length}}</q-badge>
        </q-tab>
        <q-tab name="Segue viagem" :class="option === 'Segue viagem' ? 'selected' : 'unselected'">
          <i class="ri-suitcase-3-line" style="font-size: 25px"></i>
          <span>Segue viagem</span>
          <q-badge
            :style="option === 'Segue viagem' ? 'background: #004923; color: white;' : 'background: #808285; color: black'"
            class="text-white text-bold"
            floating
            style="margin-right: 28px; margin-top: -3px; border-radius: 100%"
          >{{filterType('Segue viagem').length}}</q-badge>
        </q-tab>
      </q-tabs>
      <q-list v-for="(p, index) in filterType(option)" :key="index" style="padding:10px 20px">
        <q-card class="no-shadow" style="border-radius: 10px">
          <div class="column q-py-sm q-px-md">
            <span class="text-black text-weight-bold">{{p.name}}</span>
            <span>{{p.document_type}}: {{p.document_number}}</span>
            <span>Poltrona: {{p.seat}}</span>
          </div>
          <q-separator></q-separator>
          <div class="row items-center justify-between q-px-md">
            <div v-if="p.have_luggage !== ''" class="q-py-sm">
              <q-btn
                @click="passengerDetails = p, dialog = true"
                flat
                class="row items-center"
                padding="none"
              >
                <i class="ri-suitcase-3-line q-pr-sm" style="font-size: 25px; color:#004923"></i>
                <span class="text-weight-bold" style="color: #004923;">VER BAGAGENS</span>
              </q-btn>
            </div>
            <div v-else class="row items-center q-py-sm">
              <i class="ri-suitcase-3-line q-pr-sm" style="font-size: 25px; color:#7A8583"></i>
              <span class="text-weight-bold" style="color: #7A8583;">SEM BAGAGENS</span>
            </div>
            <q-separator vertical></q-separator>
            <div class="q-py-sm">
              <q-btn
                @click="searchBPe(p.pass_code, p.pass_ticket, p.pass_model, p.pass_serie)"
                flat
                padding="none"
                class="row items-center"
              >
                <i class="ri-suitcase-3-line q-pr-sm" style="font-size: 25px; color:#004923"></i>
                <span class="text-weight-bold" style="color: #004923;">Vizualizar BPe</span>
              </q-btn>
            </div>
          </div>
        </q-card>
      </q-list>
    </div>
    <q-dialog
      v-model="dialog"
      @hide="luggageLanding = []"
      position="right"
      :maximized="$q.screen.width < 1024 ? true : false"
      style="height: 100vh; max-height: 100vh"
    >
      <q-card style="height: 100vh; max-height: 100vh; width:100vw">
        <q-card-section class="row items-center">
          <q-space />
          <div class="text-h6 text-bold q-pl-md">DETALHES</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section class="q-pa-none">
          <div class="manual">
            <div class="manual__info">
              <div class="q-pb-sm" style="font-size:16px">
                <span class="text-black text-weight-bold text-capitalize">{{ passengerDetails.name}}</span>
                <div>
                  <span>{{ passengerDetails.document_type }}:&nbsp;</span>
                  <span>{{ passengerDetails.document_number }}</span>
                </div>
                <span>Poltrona: {{passengerDetails.seat}}</span>
              </div>
              <q-separator></q-separator>
              <div class="q-pt-md">
                <div class="row items-center q-pl-xs">
                  <div
                    style="width: 10px; height: 10px; background: #616264; border-radius:100%"
                    class="shadow-2"
                  ></div>
                  <span
                    class="q-pl-sm"
                    style="color: #707070"
                  >{{ cityToCamelCase(passengerDetails.boarding_name+'-'+passengerDetails.boarding_uf) }}</span>
                </div>
                <div class="row items-center q-pl-xs q-pb-xs">
                  <div
                    style="width: 10px; height: 10px; background: #20C600; border-radius:100%"
                    class="shadow-2"
                  ></div>
                  <span
                    class="q-pl-sm text-weight-bold"
                    style="color: #000000"
                  >{{ cityToCamelCase(passengerDetails.landing_name+'-'+passengerDetails.landing_uf) }}</span>
                </div>

                <div style="font-size: 13px; color: #7A8583; padding-left: 5px">
                  <span>Saída dia&nbsp;</span>
                  <span
                    class="departure--semi-bold"
                  >{{ passengerDetails.departure_travel | formatDate }}</span>
                </div>
                <div style="font-size: 13px; color: #7A8583; padding-left: 5px">
                  <span>Saída da agência&nbsp;</span>
                  <span class="departure--semi-bold">{{ passengerDetails.departure | formatDate }}</span>
                </div>
              </div>
            </div>

            <div class="luggage">
              <q-list
                v-for="(b, index) in passengerDetails.have_luggage.split(',')"
                :key="index"
                class="q-pb-sm"
              >
                <q-card class="luggage__grid items-center no-shadow" style="border-radius: 10px">
                  <div>
                    <i class="ri-suitcase-3-line" style="color: #004923; font-size: 28px"></i>
                  </div>
                  <div class="column" style="line-height: 1.2">
                    <span style="color:#7A8583">Bagagem</span>
                    <span style="color: #DA2128">
                      <span class="text-weight-bold">ETIQUETA</span>
                      {{b.trim().split(' ')[0]}}
                    </span>
                  </div>
                  <q-checkbox v-model="luggageLanding" :val="funcTrim(b)"></q-checkbox>
                </q-card>
              </q-list>
            </div>
            <div class="fixed-bottom">
              <q-btn
                @click="confirm = true"
                no-caps
                unelevated
                label="Desembarcar passageiro Modo Off-line"
                color="primary"
                class="full-width q-py-sm text-weight-bold"
                style="font-size: 16px"
              />
            </div>
          </div>
        </q-card-section>
        <q-dialog v-model="confirm" persistent>
          <q-card>
            <q-card-section
              class="row items-center"
              style="display: grid; grid-template-columns: max-content 1fr"
            >
              <q-avatar icon="warning" color="grey-7" text-color="white" />
              <span
                class="q-ml-md"
                style="font-size: 15px"
              >Você realmente deseja prosseguir com desembarque off-line? após esse processo feito não é possível cancelar</span>
            </q-card-section>

            <q-card-actions align="right">
              <q-btn no-caps flat label="Cancelar" color="red" v-close-popup />
              <q-btn
                no-caps
                unelevated
                @click="disembark()"
                label="Confirmar"
                color="primary"
                v-close-popup
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </q-card>
    </q-dialog>
    <q-dialog v-model="dialogBPe" @hide="ticket = ''" position="right" :maximized="true">
      <q-card style="min-width: 100vw; min-height: 100vh">
        <q-card-section class="row items-center">
          <div class="text-h6 text-bold q-pl-md">BPe</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator></q-separator>
        <q-card-section class="q-pa-none">
          <bpeLayout :passagem="ticket"></bpeLayout>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mutations } from "../store";
import { formatDate, getHost } from "../functions";
import {
  getLocalStorage,
  setLocalStorage,
  cityToCamelCase,
} from "../functions";
import {
  HISTORY_TRAVEL,
  DISEMBARK_OFFLINE,
  USER_ID,
} from "../variables";
import moment from "moment";
export default {
  name: "HistoryPassengers",
  components: {
    bpeLayout: () => import("../components/BPeLayout.vue"),
  },
  computed: {
    historiesTravel: {
      get() {
        return getLocalStorage(HISTORY_TRAVEL)
          ? getLocalStorage(HISTORY_TRAVEL)
          : [];
      },
    },
  },
  filters: {
    formatDate,
  },
  mounted() {
    mutations.setHeaderTitle("DETALHES");
    this.travelDetails = this.historiesTravel[this.$route.params.index];
  },
  data() {
    return {
      travelDetails: null,
      option: "Embarque",
      dialog: false,
      confirm: false,
      passengerDetails: {
        have_luggage: "",
      },
      luggageLanding: [],
      dialogBPe: false,
      ticket: "",
    };
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        if (getLocalStorage(DISEMBARK_OFFLINE)) {
          for (const v of getLocalStorage(DISEMBARK_OFFLINE)) {
            this.luggageLanding.push(v.valueCheckbox);
          }
        }
      }
    },
  },
  methods: {
    cityToCamelCase,
    searchBPe(codigo, bilhete, modelo, serie) {
      window.http
        .get(
          getHost() +
            `/eucaturmobile/dabpe?codigo=${codigo}&bilhete=${bilhete}&modelo=${modelo}&serie=${serie}`
        )
        .then((r) => {

          if (r.data.message === "BPe não disponível") {
            mutations.openAlert({
                open: true,
                message: r.data.message,
                status: r.status,
            });
            return
          }
            
          this.ticket = r.data;
          this.dialogBPe = true;
        }).catch(() => {
          mutations.openAlert({
              open: true,
              message: "BPe na fila de emissão, por favor aguarde.",
              status: 200,
            });
        })
    },
    filterType(type) {
      return this.travelDetails.passengers.filter((v) => v.type === type);
    },
    disembark() {
      var disembarkOfflineLocal = getLocalStorage(DISEMBARK_OFFLINE)
        ? getLocalStorage(DISEMBARK_OFFLINE)
        : [];

      for (const v of this.luggageLanding) {
        let l = v.trim().split(" ");
        let params = {
          number: l[0].trim(),
          serie: l[1].trim(),
          model: l[2].trim(),
          company: l[3].trim(),
          sync: false,
          user_id: getLocalStorage(USER_ID),
          valueCheckbox: v,
          datetime: moment().format(),
        };

        if (
          !disembarkOfflineLocal.find(
            (v) => v.valueCheckbox === params.valueCheckbox
          )
        ) {
          mutations.openAlert({
            open: true,
            message: "Bagagem " + l[0] + " adicionado a lista de desembarque",
            status: 300,
          });
          disembarkOfflineLocal.push(params);
        }
      }
      setLocalStorage(DISEMBARK_OFFLINE, disembarkOfflineLocal);
    },
    funcTrim(value) {
      return value.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
%city-circle {
  $size: 12px;

  display: block;
  width: $size;
  height: $size;
  border-radius: 50%;
}

%city-grid {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: max-content 1fr;

  align-items: center;
  font-weight: 500;
}

.boarding__history {
  background-color: #ffffff;
  box-shadow: 0 3px 4px 0 #eeeff295;

  .travel__schedule {
    display: grid;
    grid-row-gap: 8px;
    grid-template-rows: max-content;
    justify-items: center;

    .schedule__info {
      display: grid;
      width: 90%;

      .info__bus {
        display: grid;
        grid-column-gap: 4px;
        grid-template-columns: repeat(2, max-content);

        place-items: center;
        margin-bottom: 8px;
        margin-left: -4px;
      }

      .info__bus--color {
        color: #172c20;
        font-weight: 600;
      }

      .circle-origin {
        background-color: #7a8583;
        @extend %city-circle;
      }

      .circle-destiny {
        background-color: #20c600;
        @extend %city-circle;
      }

      .info__origin {
        color: #707070;
        @extend %city-grid;
      }

      .info__destiny {
        color: #040006;
        @extend %city-grid;
      }
    }
  }
}

.passengers__history {
  background: #e5e5e5;
  min-height: 100vh;
  height: 100%;

  .tabs {
    .selected {
      color: #004923;
      font-weight: 600;
    }
    .unselected {
      color: #808285;
      font-weight: 500;
    }
  }
}

.manual {
  background: #e5e5e5;
}

.manual__info {
  background-color: #ffffff;
  padding: 20px;
}

.luggage {
  background: #e5e5e5;
  padding: 20px;
  height: 80vh;

  .luggage__grid {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    padding: 20px;
    gap: 10px;
  }
}
</style>